module.exports = __webpack_public_path__ + "img/BLANCO_Training.893b7e09.png";